import { render, staticRenderFns } from "./StoresBase.vue?vue&type=template&id=373c0686&scoped=true&"
import script from "./StoresBase.vue?vue&type=script&lang=ts&"
export * from "./StoresBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c0686",
  null
  
)

export default component.exports